class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.observer();
    this.updateOptions();
    this.updateMasterId();
    this.updateVariantPicker();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updateVariantPicker();
    this.updatePickupAvailability();
    this.updateInventoryStatus();
    this.removeErrorMessage();
    this.updateSKU();
    this.updateOmnibusPrice();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
      this.updateBanner();
      this.updateStoreInformation();
    }
  }

  observer() {
    const buyBanner = document.getElementById('buyBanner');
    if (!buyBanner) return;
    const iObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.intersectionRatio < 0.8 && this.getBoundingClientRect().y < 0) {
            buyBanner.classList.remove('product__selling-banner--animation-close');
            buyBanner.classList.add('product__selling-banner--animation-open');
          } else {
            buyBanner.classList.add('product__selling-banner--animation-close');
            buyBanner.classList.remove('product__selling-banner--animation-open');
          }
        });
      },
      { threshold: [0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0] }
    );
    iObserver.observe(this);
  }

  updateBanner() {
    const bannerInfo = document.getElementById('banner-info');

    if (!bannerInfo) return;
    bannerInfo.innerHTML = this.currentVariant.title;

    const bannerImage = document.querySelectorAll('[data-banner-image]');

    bannerImage.forEach((elem) => {
      if (this.currentVariant.title.toLowerCase().includes(elem.dataset.variantColor)) {
        elem.dataset.variantSelected = true;
      } else {
        elem.dataset.variantSelected = false;
      }
    });
  }

  updateSKU() {
    const techDetails = document.getElementById('techDetailsSkuValue');
    if (!techDetails) return;
    techDetails.innerHTML = this.currentVariant.sku;
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    if (this.dataset.variantId) {
      this.currentVariant = this.getVariantData().find((variant) => {
        return variant.id == this.options[0];
      });
    } else {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options
          .map((option, index) => {
            return this.options[index] === option;
          })
          .includes(false);
      });
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if (!mediaGallery) return;
    mediaGallery.showVariantImages(this.currentVariant.option1);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantPicker() {
    this.currentVariantSiblings = [];
    this.currentVariantSiblings.push(this.getVariantData().filter((variant) => variant.options[0] == this.options[0]));
    for (let i = 1; i < this.options.length; i++) {
      const optionInputs = document.querySelectorAll(`[id^="${this.dataset.section}-${i + 1}"]`);

      if (optionInputs.length == 0) {
        return;
      }
      optionInputs.forEach((elem) => {
        let inputVariant = this.currentVariantSiblings[i - 1].find((variant) => variant.options[i] == elem.value);
        if (inputVariant.available) {
          elem.classList.remove('sold-out');
        } else {
          elem.classList.add('sold-out');
        }
      });
      this.currentVariantSiblings.push(this.currentVariantSiblings[i - 1].filter((variant) => variant.options[i] == this.options[i]));
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updateInventoryStatus() {
    this.productInventoryNode = document.querySelector('[data-product-inventory]');

    if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;

    this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
    this.showInStockLabel = this.productInventoryNode.dataset.showInStock;

    const variantInventoryObject = window.inventories[this.dataset.productId][this.currentVariant.id];

    if (!this.currentVariant || !this.currentVariant.inventory_management || variantInventoryObject.policy === 'continue') {
      this.toggleInventoryQuantity(false);
      // this.toggleIncomingInventory(false);

      return;
    }

    if (this.currentVariant.inventory_management === 'shopify') {
      if (variantInventoryObject.policy === 'continue') {
        this.toggleInventoryQuantity(false);
        // this.toggleIncomingInventory(false);

        return;
      }

      if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
        this.toggleInventoryQuantity(false);
        // this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
      } else {
        this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
        // this.toggleIncomingInventory(false);
      }
    }
  }

  toggleInventoryQuantity(show, quantity) {
    if (show == false) {
      this.productInventoryNode.classList.add('hide');

      return;
    }

    if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold)) {
      this.productInventoryNode.classList.add('inventory-status--low');
      this.productInventoryNode.firstElementChild.innerHTML = '<div class="dot"></div>' + window.variantStrings.inventory.few_left;
      this.productInventoryNode.classList.remove('hide');
    } else if (this.currentVariant && this.currentVariant.available && this.showInStockLabel == 'true') {
      this.productInventoryNode.classList.remove('inventory-status--low');
      this.productInventoryNode.firstElementChild.innerHTML = '<div class="dot"></div>' + window.variantStrings.inventory.in_stock;
      this.productInventoryNode.classList.remove('hide');
    } else {
      this.productInventoryNode.classList.add('hide');
    }
  }

  toggleIncomingInventory(show, date) {
    const incomingInventoryNode = document.querySelector('[data-incoming-inventory]');

    if (show == false && incomingInventoryNode) {
      incomingInventoryNode.classList.add('hide');

      return;
    }

    let string = !date ? window.variantStrings.inventory.waiting_for_stock : window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);

    incomingInventoryNode.classList.remove('hide');
    incomingInventoryNode.firstElementChild.textContent = string;
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const bannerDestination = document.getElementById('banner-price');
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && bannerDestination) bannerDestination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');

      if (text) {
        addButtonText.textContent = text;
      }
    } else {
      addButton.removeAttribute('disabled');
      addButton.classList.remove('hidden');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    const bannerAddButton = document.getElementById('buy-banner-button');

    if (!bannerAddButton) return;

    const bannerAddButtonText = bannerAddButton.querySelector('span');
    if (disable) {
      bannerAddButton.setAttribute('disabled', 'disabled');
      if (text) {
        bannerAddButtonText.textContent = text;
      }
    } else {
      bannerAddButton.removeAttribute('disabled');
      bannerAddButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }

  async updateStoreInformation() {
    const storeAvailabilityHTML = await this.getStoreAvailability(this.dataset.url, this.currentVariant.id);

    const storeAvailabilityInfo = document.getElementById('store-availability-info');
    if (!storeAvailabilityInfo) return;
    storeAvailabilityInfo.innerHTML = storeAvailabilityHTML;
  }

  getStoreAvailability(productURL, variantID) {
    var requestResponse;
    return fetch(`${productURL}?view=store-availability&variant=${variantID}`)
      .then((response) => {
        requestResponse = response;
        return response.text();
      })
      .then((text) => {
        if (!requestResponse.ok) {
          throw new Error(`${requestResponse.status}: ${text}`);
        }

        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#store-availability-inner').innerHTML;

        return Promise.resolve(resultsMarkup);
      })
      .catch((error) => {
        console.error(error);
      });
  }

  updateOmnibusPrice() {
    // Update banner price only, other Omnibus elements get updated/render dynamically with JS
    const omnibusContainer = document.querySelector('.banner-omnibus .omnibus-price');
    const omnibusPrice = omnibusContainer.querySelector('[data-omnibus-price]');
    const onlyOnSaleSetting = omnibusContainer.dataset.omnibusOnSaleOnly == 'true';
    const variant = this.currentVariant;
    const onSale = !!variant.compare_at_price && variant.compare_at_price > variant.price;
    const variantPrice = variantOmnibusPrices[variant.id];

    // Update and show price if variant is on sale or set always to visible , otherwise hide element
    if (variantPrice && (onSale || !onlyOnSaleSetting)) {
      omnibusPrice.textContent = Woolman.Utils.formatMoney(variantPrice, theme.settings.moneyFormat);
      if (omnibusContainer.classList.contains('hide')) omnibusContainer.classList.remove('hide');
    } else {
      omnibusContainer.classList.add('hide');
    }
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

(function () {
  const history = sessionStorage.getItem('Woolman_Product_History') ? sessionStorage.getItem('Woolman_Product_History').split(',') : [];
  const productHandle = window.location.pathname.split('/').pop();
  if (!productHandle) return;
  if (!history.includes(productHandle)) {
    if (history.length >= 10) {
      // only store up to 10 recently viewed products
      history.shift();
    }

    history.push(productHandle);
    sessionStorage.setItem('Woolman_Product_History', history.join(','));
  }
})();

class ProductSliderComponent extends SpliderParent {
  constructor() {
    super();
    const arrows = this.querySelector('.splide__arrows');

    this.addEventListener('mounted', (evt) => {
      evt.detail.splide.on('active', (slide) => {
        const hasModelViewer = slide.slide.querySelector('model-viewer') ? true : false;
        if (hasModelViewer) {
          arrows.classList.remove('js-hide-arrows');
        } else {
          arrows.classList.add('js-hide-arrows');
        }
      });
    });
  }

  showVariantImages(variantOption) {
    var updateSlider = false;
    if (this.classList.contains('splide--slide')) {
      updateSlider = true;
      this.disallowMounting();
    }

    const media = document.querySelectorAll('[data-variant]');
    media.forEach((element) => {
      if (element.attributes['data-hide-variant-image'] && element.attributes['data-variant'].value == variantOption) {
        element.toggleAttribute('data-hide-variant-image');
        element.setAttribute('data-class', 'splide__slide');
      } else if (!element.attributes['data-hide-variant-image'] && element.attributes['data-variant'].value != variantOption) {
        element.toggleAttribute('data-hide-variant-image');
        element.removeAttribute('data-class', 'splide__slide');
      }
    });
    this.setAttribute('data-selected-variant', variantOption);
    if (updateSlider) {
      this.allowMounting();
    }
  }

  setActiveMedia(htmlElementId) {
    const mediaNode = document.querySelector(`[data-media-id="${htmlElementId}"]`);

    if (!mediaNode) return;

    if (!mediaNode.classList.contains('splide__slide')) {
      window.scrollTo({
        top: mediaNode.offsetTop,
        behavior: 'smooth',
      });
      return;
    }
    const mediaNodeIndex = parseInt(mediaNode.dataset.index) || 0;
    this.splide.go(mediaNodeIndex);
  }
}

customElements.define('product-slider-component', ProductSliderComponent);

function scrollToVariantPicker(id) {
  const target = document.getElementById(id);
  const targetPosition = target.getBoundingClientRect().top;
  const headerHeight = document.getElementById('MainHeader').offsetHeight;
  const scrollPosition = targetPosition + window.pageYOffset - headerHeight;

  window.scrollTo({
    top: scrollPosition,
    behavior: 'smooth',
  });
}

function toggleSizeGuide() {
  document.body.classList.toggle('prevent-scrolling');
  const sizeGuide = document.getElementById('sizeGuide');
  sizeGuide.classList.toggle('hidden');
}

function changeRadioTitle(input) {
  const valueElement = input.parentElement.querySelector('#radioValueText');
  valueElement.innerHTML = input.value;
}
